// @flow
import React from 'react'
import classnames from 'classnames'

import IconSearch from '../../icons/IconSearch'

type PropsT = {
  value: string,
  onChange: Function,
  autoFocus?: boolean,
  placeholder?: string,
  className?: string,
  name?: string,
  id?: string
}

const SearchInput = ({ className, autoFocus = false, placeholder, value, onChange, name = 'search', id = 'search', ...rest }: PropsT) => (
  <div className={classnames('SearchInput__container', className)}>
    <div className='SearchInput__icon'>
      <IconSearch />
    </div>
    <input
      ref={(input) => { if (autoFocus && input) input.focus() }}
      className='SearchInput'
      type='search'
      name={name}
      id={id}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      {...rest}
    />
  </div>
)

export default SearchInput
